import { render, staticRenderFns } from "./r-currency-formula-panel.vue?vue&type=template&id=1ed96d0f"
import script from "./r-currency-formula-panel.vue?vue&type=script&lang=js"
export * from "./r-currency-formula-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed96d0f')) {
      api.createRecord('1ed96d0f', component.options)
    } else {
      api.reload('1ed96d0f', component.options)
    }
    module.hot.accept("./r-currency-formula-panel.vue?vue&type=template&id=1ed96d0f", function () {
      api.rerender('1ed96d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-formula-panel.vue"
export default component.exports